import { forwardRef, type HTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "./utils";

const badgeVariants = cva(
  [
    "inline-flex items-center gap-1 whitespace-nowrap",
    "rounded-xs px-1.5 py-0.5 text-2xs font-medium",
  ],
  {
    variants: {
      tone: {
        neutral:  "bg-base-100 text-base-700",
        primary:  "bg-primary-50 text-primary-800",
        ai:       "bg-ai-50 text-ai-800",
        heritage: "bg-heritage-50 text-heritage-800",
        success:  "bg-success-50 text-success-700",
        danger:   "bg-danger-50 text-danger-700",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {
  dot?: boolean;
}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, tone, dot, children, ...props }, ref) => (
    <span ref={ref} className={cn(badgeVariants({ tone, className }))} {...props}>
      {dot && <span className="size-1.5 rounded-full bg-current" aria-hidden="true" />}
      {children}
    </span>
  ),
);
Badge.displayName = "Badge";
